export default __webpack_public_path__ + "static/media/address-card-solid.cc3890bf.svg";